(() => {
  'use strict';
  if (window.__MMG_COMMERCIAL_MEASUREMENT_V1__) return;
  window.__MMG_COMMERCIAL_MEASUREMENT_V1__ = true;

  const STORAGE_KEY = 'mmg.commercial-attribution.v1';
  const EVENT_NAME = 'mmg:commercial:measure';
  const TRACKABLE_SELECTOR = 'a,button,input[type="submit"]';
  const clean = (value, max = 240) => {
    const text = String(value || '').trim();
    return text ? text.slice(0, max) : null;
  };

  function readStored() {
    try {
      const value = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
      return value && typeof value === 'object' ? value : {};
    } catch (_) {
      return {};
    }
  }

  function writeStored(value) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value)); } catch (_) {}
  }

  function getAttribution() {
    const params = new URLSearchParams(window.location.search);
    const prior = readStored();
    const current = {
      source: clean(params.get('utm_source') || params.get('source')),
      medium: clean(params.get('utm_medium') || params.get('medium')),
      campaign: clean(params.get('utm_campaign') || params.get('campaign')),
      content: clean(params.get('utm_content')),
      term: clean(params.get('utm_term')),
      gclid: clean(params.get('gclid'), 120),
      fbclid: clean(params.get('fbclid'), 120),
      landingPath: prior.landingPath || window.location.pathname,
      firstSeenAt: prior.firstSeenAt || new Date().toISOString(),
      referrer: prior.referrer || clean(document.referrer, 500)
    };
    const firstTouch = prior.firstTouch || Object.fromEntries(Object.entries(current).filter(([key, value]) => value && !['landingPath','firstSeenAt','referrer'].includes(key)));
    const lastTouch = Object.fromEntries(Object.entries(current).filter(([key, value]) => value && !['landingPath','firstSeenAt','referrer'].includes(key)));
    const preview = params.has('preview_theme_id') || !!document.querySelector('#PBarNextFrame');
    const internal = preview || params.get('mmg_internal') === '1' || prior.internal === true;
    const next = { version: 'commercial-attribution-v1', firstTouch, lastTouch, landingPath: current.landingPath, firstSeenAt: current.firstSeenAt, referrer: current.referrer, internal };
    writeStored(next);
    return next;
  }

  const attribution = getAttribution();
  const context = Object.freeze({
    version: 'commercial-measurement-v1',
    path: window.location.pathname,
    pageType: clean(document.body?.dataset?.template, 80) || clean(document.body?.className, 160),
    internal: attribution.internal,
    attribution
  });

  function track(type, detail = {}) {
    const payload = {
      event: type,
      version: 'commercial-measurement-v1',
      occurredAt: new Date().toISOString(),
      path: window.location.pathname,
      internal: context.internal,
      attribution: context.attribution,
      ...detail
    };
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: payload }));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    return payload;
  }

  function labelFor(element) {
    return clean(element?.getAttribute?.('aria-label') || element?.textContent || element?.value, 180);
  }

  function destinationFor(element) {
    return clean(element?.getAttribute?.('href') || element?.formAction || element?.closest?.('form')?.getAttribute?.('action'), 500);
  }

  function init() {
    window.MMGCommercialMeasurement = Object.freeze({
      version: 'v1',
      getContext: () => ({ ...context, attribution: JSON.parse(JSON.stringify(context.attribution)) }),
      track
    });

    track('page_view', { title: clean(document.title, 220) });

    document.addEventListener('click', (event) => {
      const element = event.target?.closest?.(TRACKABLE_SELECTOR);
      if (!element || element.dataset.mmgMeasurementTracked === 'true') return;
      element.dataset.mmgMeasurementTracked = 'true';
      const destination = destinationFor(element);
      const label = labelFor(element);
      if (element.matches('[data-subscription-add]')) {
        track('subscription_add_to_cart_intent', { label, destination });
      } else if (destination === '/checkout' || destination?.includes('/checkout')) {
        track('checkout_start_intent', { label, destination });
      } else if (destination?.includes('/cart') || element.closest('form[action*="/cart/add"]')) {
        track('add_to_cart_intent', { label, destination });
      } else if (label || destination) {
        track('cta_click', { label, destination });
      }
    }, { capture: true });

    document.addEventListener('focusin', (event) => {
      const form = event.target?.closest?.('form');
      if (!form || form.dataset.mmgLeadStartTracked === 'true') return;
      const action = form.getAttribute('action') || '';
      if (form.querySelector('input[type="email"],textarea,[name="contact[body]"]') || action.includes('/contact')) {
        form.dataset.mmgLeadStartTracked = 'true';
        track('lead_form_start', { form: clean(form.getAttribute('id') || action, 180) });
      }
    }, { capture: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();